"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToSlug = void 0;
const stringToSlug = stringText => {
    let str = stringText.replace(/^\s+|\s+$/g, "");
    str = str.toLowerCase();
    const from = "ąàáäâćęèéëêìíïîłòóöôśùúüûñńçěščřžýúůďťňżź·/_,:;";
    const to = "aaaaaceeeeeiiiiloooosuuuunncescrzyuudtnzz------";
    for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }
    str = str
        .replace(".", "-")
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/\//g, "");
    return str;
};
exports.stringToSlug = stringToSlug;
//# sourceMappingURL=string-modifier.js.map